import { render, staticRenderFns } from "./PageHeroDescription.vue?vue&type=template&id=c25822d8&scoped=true&"
import script from "./PageHeroDescription.vue?vue&type=script&lang=ts&"
export * from "./PageHeroDescription.vue?vue&type=script&lang=ts&"
import style0 from "./PageHeroDescription.vue?vue&type=style&index=0&id=c25822d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25822d8",
  null
  
)

export default component.exports